import React from 'react';
export default function ProductSpecificationsData(minAge, maxAge) {
    return {
        video: {
            name: "About Disability Insurance",
            link: "https://player.vimeo.com/video/213549541"
        },
        image: "product-landing/disa/circle1.png",
        specs: [
            {
                title: "Eligibility",
                text: `${minAge}-${maxAge} years`,
            },
            {
                title: "Benefit amounts",
                text: "Based on a portion of your income up to $5,000 for short term, $12,000 for long term, and up to $100,000 for lump sum.",
            },
            {
                title: "Who can apply?",
                text: `U.S. citizens or permanent residents`
            },
            {
                title: "Elimination periods",
                text: <span>7, 14, 30, 60, or 90 days (for short-term disability),<br />60, 90, 180, or 365 days (for long-term disability)</span>
            },
            {
                title: "Benefit Period",
                text: "3, 6, 12, or 24 months (short-term disability), 2, 5, or 10 years, or to age 67 (long-term disability)."
            }
        ],
        hideNeedsAnalysis: true
    }
}